import Vue from "vue";
import VCalendar from "v-calendar";
import installManagementCalendar from "@shared/installManagementCalendar.cjs";

installManagementCalendar({ Framework: Vue, CalendarLibrary: VCalendar });
